<div class="row">
    <div class="col-12 ">
        <label for="url" class="form-label">Url</label>
        <input type="text" class="form-control" id="url" name="url" ngModel #url="ngModel" [(ngModel)]="authConfig.url"
            required />
    </div>
    <div class="col-12 ">
        <label for="url" class="form-label">ApiKey</label>
        <div class="input-group">
            <input type="{{ showApiKey ? 'text' : 'password' }}" class="form-control" id="apiKey" name="apiKey" ngModel
                #url="ngModel" [(ngModel)]="authConfig.apiKey" autocomplete="new-password" required />
            <button type="button" class="btn btn-outline-secondary" (click)="showApiKey = !showApiKey" tabindex="-1">
                <i [ngClass]="showApiKey ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
            </button>
        </div>
    </div>
    <div class="col-md-6 ">
        <label for="name" class="form-label">Username</label>
        <input type="text" class="form-control" id="username" name="username" ngModel #name="ngModel" autocomplete="off"
            [(ngModel)]="authConfig.username" required />
    </div>
    <div class="col-md-6 ">
        <label for="name" class="form-label">Password</label>

        <div class="input-group">
            <input type="{{ showPassword ? 'text' : 'password' }}" class="form-control" id="password" name="password"
                autocomplete="new-password" ngModel #name="ngModel" [(ngModel)]="authConfig.password" required />
            <button type="button" class="btn btn-outline-secondary" (click)="showPassword = !showPassword"
                tabindex="-1">
                <i [ngClass]="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
            </button>
        </div>
    </div>
    <div class="col-md-6 ">
        <label for="cityCode" class="form-label">Codice Comune</label>
        <input type="text" class="form-control" id="cityCode" name="cityCode" ngModel #cityCode="ngModel"
            [(ngModel)]="authConfig.cityCode" required />
    </div>
    <div class="col-md-6">
        <label for="officeId" class="form-label">Ufficio</label>
        <select id="officeId" name="officeId" class="form-select" ngModel #officeId="ngModel"
            [(ngModel)]="authConfig.officeId">
            <option value="1">Scuola e Pubblica Istruzione</option>
            <option value="2">Sociali/Sociosanitari - Welfare</option>
            <option value="3">Biblioteche</option>
            <option value="4">Governo del Territorio - Sportelli Edilizia</option>
            <option value="5">Tributi</option>
            <option value="6">Cimiteri</option>
            <option value="7">Ambiente</option>
            <option value="8">Segreteria Generale - Organi Istituzionali - Circoscrizioni, Decentramento, Quartieri,
                Istituti di partecipazione</option>
            <option value="9">Avvocatura e Uffici competenti per Ordinanze - Ingiunzioni</option>
            <option value="10">Notifiche e Spedizioni</option>
            <option value="11">Personale - Risorse Umane</option>
            <option value="12">Patrimonio mobiliare ed immobiliare</option>
            <option value="13">Espropri</option>
            <option value="14">Igiene e Sanità Pubblica - Animali d'affezione - Inquinamento</option>
            <option value="16">Stazione Unica Appaltante</option>
            <option value="17">Manutenzioni Lavori Pubbliche, Strade, Infrastrutture, Reperibilità</option>
            <option value="18">Ragioneria e Servizi Finanziari</option>
            <option value="19">Economato</option>
            <option value="20">Polizia Locale - Attività di Polizia Giudiziaria e Servizi della Centrale Operativa
            </option>
            <option value="21">Polizia Locale - Attività Amministrative</option>
        </select>
    </div>
    <div class="col-md-6 ">
        <label for="name" class="form-label">Realm</label>
        <input type="text" class="form-control" id="realm" name="realm" ngModel #name="ngModel"
            [(ngModel)]="authConfig.realm" required />


    </div>
</div>